/**
 * iconResolver.ts — Type-safe icon lookup for module icons.
 *
 * Part of the Content domain (DDD B3).
 * Moved from src/utils/iconResolver.ts.
 *
 * Replaces the repeated `(Icons as any)[module.icon] || Icons.BookOpen`
 * pattern found in 8+ files with a single typed utility.
 */

import * as Icons from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

const iconMap = Icons as unknown as Record<string, LucideIcon>

/**
 * Resolve a module icon by name string.
 * Falls back to BookOpen if the icon name is not found.
 *
 * @example
 * const Icon = getModuleIcon(module.icon)
 * return <Icon className="w-5 h-5" />
 */
export function getModuleIcon(iconName: string): LucideIcon {
  return iconMap[iconName] || Icons.BookOpen
}
